import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-state-modal',
  imports: [],
  templateUrl: './error-state-modal.component.html'
})
export class ErrorStateModalComponent {
  @Input() title!: string;
  @Input() alertMessage!: string;

  public readonly activeModal = inject(NgbActiveModal);

  closeModal(): void {
    this.activeModal.close();
  }
}

